// extracted by mini-css-extract-plugin
export default {"menuListTitle":"MenuListTitle_menuListTitle__yQtvI"};